import { DropdownOption } from '../../component/dropDownMenu/dropDownMenu.type';
import { Trans } from 'react-i18next';
import DropdownMenu from '../../component/dropDownMenu/dropDownMenu';
import {
  GetUsersResponse,
  OrganizationUnitNameAndId,
  OrganizationUnitType,
  UserStatus,
} from '@inplay/models';
import {
  getStatusDotColor,
  validateAndDecodeAuthToken,
} from '../../utils/helper';
import { SortKey, TableHeader } from '../../component/table/table.type';
import { ReactNode, useState } from 'react';
import { Option } from '../../component/dropDownInput/dropDownInput.type';
import ActionButton from '../../component/button/button';
import Close from '../../assets/close.png';
import moment from 'moment';
import {
  ActionButtonsVisibility,
  ActiveStaffOption,
  AddButtonWithDropdownProps,
  KebabOption,
  OptionWithLoading,
  OrganisationToggleEnum,
  UserKey,
  UserManagementHeaderKey,
  UserType,
} from './userManagement.type';
import { camelCase, startCase } from 'lodash';
import { AuthTokenResponse } from '../../service/service.type';
import UserActive from '../../assets/user_active.png';
import UserInActive from '../../assets/user.inactive.png';
import VenueActive from '../../assets/venue_active.png';
import VenueInActive from '../../assets/venues_inactive.png';
import OrganisationActive from '../../assets/organization_active.png';
import OrganisationInactive from '../../assets/organization_inactive.png';
import { OrganisationOptionProps } from '../../component/organisationToggle/organisationToggle.type';
import AddButton from '../../component/button/button';
import {
  GroupedOrganizationUnit,
  GroupedSubOrganizationType,
  GroupedVenueType,
} from '../../service/context/organizationContext.types';
import { OrganizationUnitChildItem } from '../../component/organizationUnitDropdown/organizationUnitDropdown.type';

export const settingMenuOption: DropdownOption[] = [
  {
    label: 'userManagement.settingOption.viewUniversalStaff',
  },
  {
    label: 'userManagement.settingOption.editUniversalStaff',
  },
  {
    label: 'userManagement.settingOption.editVenue',
  },
  {
    label: 'userManagement.settingOption.deleteVenue',
  },
];

export const downloadOption = [
  { label: 'userManagement.settingOption.download' },
];
export const addVenueBranchOption = [
  { label: 'userManagement.settingOption.createVenueBranch' },
];

export const OrganisationToggleOption: OrganisationOptionProps[] = [
  {
    value: OrganisationToggleEnum.VENUE_USERS,
    activeIcon: UserActive,
    inActiveIcon: UserInActive,
    label: OrganisationToggleEnum.VENUE_USERS,
  },
  {
    value: OrganisationToggleEnum.VENUES,
    activeIcon: VenueActive,
    inActiveIcon: VenueInActive,
    label: OrganisationToggleEnum.VENUES,
  },
  {
    value: OrganisationToggleEnum.ORGANISATION,
    activeIcon: OrganisationActive,
    inActiveIcon: OrganisationInactive,
    label: OrganisationToggleEnum.ORGANISATION,
  },
];

export enum AddMenuOption {
  ADD_USER = 'addUser',
  ADD_VENUE_BRANCH = 'addVenueBranch',
}

export const addMenuOptionsforUserManagement: DropdownOption<AddMenuOption>[] =
  [
    {
      label: 'userManagement.add',
      optionKey: AddMenuOption.ADD_USER,
    },
  ];

export const statusOrder: UserStatus[] = [
  UserStatus.INVITED,
  UserStatus.ACTIVE,
  UserStatus.INACTIVE,
];

export const userTypeOrder: UserType[] = [
  UserType.ORGANIZATION_ADMIN,
  UserType.SUB_ORGANIZATION_ADMIN,
  UserType.VENUE_ADMIN,
  UserType.VENUE_MANAGER,
  UserType.VENUE_STAFF,
];

export const userStatusOption: Option[] = [
  { label: startCase(UserStatus.ACTIVE), value: UserStatus.ACTIVE },
  { label: startCase(UserStatus.INACTIVE), value: UserStatus.INACTIVE },
  { label: startCase(UserStatus.INVITED), value: UserStatus.INVITED },
];

export const userTypeOptions: Option[] = [
  {
    label: startCase(UserType.ORGANIZATION_ADMIN),
    value: UserType.ORGANIZATION_ADMIN,
  },
  {
    label: startCase(UserType.SUB_ORGANIZATION_ADMIN),
    value: UserType.SUB_ORGANIZATION_ADMIN,
  },
  {
    label: startCase(UserType.VENUE_ADMIN),
    value: UserType.VENUE_ADMIN,
  },
  {
    label: startCase(UserType.VENUE_MANAGER),
    value: UserType.VENUE_MANAGER,
  },
  {
    label: startCase(UserType.VENUE_STAFF),
    value: UserType.VENUE_STAFF,
  },
  {
    label: startCase(UserType.VENUE_BRANCH_LOGIN),
    value: UserType.VENUE_BRANCH_LOGIN,
  },
];

export const activeStaffOption: Option[] = [
  {
    label: ActiveStaffOption.DEACTIVATE,
    value: camelCase(ActiveStaffOption.DEACTIVATE),
  },
  {
    label: ActiveStaffOption.EDIT,
    value: camelCase(ActiveStaffOption.EDIT),
  },
  {
    label: ActiveStaffOption.DELETE,
    value: camelCase(ActiveStaffOption.DELETE),
  },
  {
    label: ActiveStaffOption.GENERATE_NEW_PIN,
    value: camelCase(ActiveStaffOption.GENERATE_NEW_PIN),
  },
];

/**
 * Renders a group of action buttons (Activate, Deactivate, Delete)
 * along with a label showing the number of selected users and a close icon.
 *
 * @param selectedCount - Number of selected users to display.
 * @param countedUnitTranslationKey - Translation key to get the text for the count of selected items (e.g., "userManagement.table.users").
 * @param onClose - Callback for when the close icon is clicked.
 * @param onActivate - Callback for Activate button.
 * @param onDeactivate - Callback for Deactivate button.
 * @param onDelete - Callback for Delete button.
 * @returns JSX.Element - A styled group of buttons and label.
 */
export const renderActionButtons = (
  selectedCount: number,
  countedUnitTranslationKey: string,
  onClose?: () => void,
  onActivate?: () => void,
  onDeactivate?: () => void,
  onDelete?: () => void,
  actionVisibility?: ActionButtonsVisibility,
) => {
  return (
    <div className="flex items-center flex-wrap gap-2">
      {actionVisibility?.isShowDeactivate && (
        <ActionButton
          className="px-8 py-2 ml-2 rounded-full text-sm bg-THEME_COLOR hover:bg-THEME_HOVER_COLOR"
          onClick={onActivate}
        >
          <Trans i18nKey="userManagement.actionButton.activate" />
        </ActionButton>
      )}

      {actionVisibility?.isShowActivate && (
        <ActionButton
          className="px-8 py-2 ml-2 bg-black text-white rounded-full text-sm hover:bg-black hover:text-white"
          onClick={onDeactivate}
        >
          <Trans i18nKey="userManagement.actionButton.deActivate" />
        </ActionButton>
      )}

      {actionVisibility?.isShowDelete && (
        <ActionButton
          className="px-8 py-2 ml-2 bg-white hover:bg-white hover:text-black text-black border rounded-full text-sm"
          onClick={onDelete}
        >
          <Trans i18nKey="userManagement.actionButton.delete" />
        </ActionButton>
      )}

      <span className="flex items-center text-[12px] text-[#092344] lowercase">
        <Trans
          i18nKey="userManagement.selectedUser"
          values={{
            count: selectedCount,
          }}
        />{' '}
        <Trans i18nKey={countedUnitTranslationKey} />
        <img
          onClick={onClose}
          src={Close}
          alt="Close"
          className="w-3 h-3 cursor-pointer ml-3"
        />
      </span>
    </div>
  );
};

/**
 * Renders the settings icon with a dropdown menu.
 *
 * @param settingIcon - The path to the settings icon image.
 * @param isOpenSettingMenu - Whether the settings dropdown is open.
 * @param toggleSettingMenu - Function to toggle the settings dropdown.
 * @param settingMenuOptions - Array of dropdown options.
 * @returns JSX.Element
 */
export const renderSettingsMenuWithDropdown = (
  settingIcon: string,
  isOpenSettingMenu: boolean,
  toggleSettingMenu: () => void,
  settingMenuOptions: DropdownOption[],
  onSettingMenuSelect: (label: string) => void,
  disabled = false,
): JSX.Element => {
  if (disabled) {
    return (
      <div className="relative inline-block mt-1 opacity-50 cursor-not-allowed">
        <img
          src={settingIcon}
          alt="Settings"
          className="w-10 h-5 mt-2.5 pointer-events-none"
        />
      </div>
    );
  }
  return (
    <div className="relative inline-block mt-1">
      <img
        src={settingIcon}
        alt="Settings"
        className="w-7 h-5  mt-2.5 cursor-pointer border-red-500"
        onClick={toggleSettingMenu}
      />
      {isOpenSettingMenu && (
        <DropdownMenu
          className="right-0 w-52"
          options={settingMenuOptions}
          onSelect={(label: string) => onSettingMenuSelect(label)}
          onClose={toggleSettingMenu}
        />
      )}
    </div>
  );
};

/**
 * Renders a labeled form row with a consistent layout.
 *
 * @param label - The label text displayed on the left side of the row.
 * @param children - The form element (e.g., input, dropdown, date picker) displayed on the right side.
 * @returns A JSX element representing a horizontal form row with label and input.
 *
 * Layout: 30% width for the label, 70% width for the input.
 * Adds top margin except for the first row.
 */
export const renderFormRow = (label: ReactNode, children: ReactNode) => (
  <div className="flex mt-4 items-start">
    <div className="w-[30%] pt-2 text-sm text-[#1A1A1A] leading-[20px] min-h-[40px]">
      {label}
    </div>
    <div className="w-[70%] min-h-[40px]">{children}</div>
  </div>
);

/**
 * Renders the "Add" button with a dropdown menu for user management (if more than one option is provided).
 * @param handleClick - Function to handle the click on the "Add" button or the dropdown menu"
 * @param addMenuOptions - Array of dropdown options. If only one option is provided, the dropdown will not be displayed.
 */
export const AddButtonWithDropdown = <OptionKey extends string = string>(
  props: AddButtonWithDropdownProps<OptionKey>,
): JSX.Element => {
  const [isOpenAddMenu, setIsOpenAddMenu] = useState<boolean>(false);
  const handleClickAddButton = () => {
    if (props.addMenuOptions.length === 1) {
      // If there's only one option, directly call the handleClick function
      // Do not display the dropdown menu
      props.handleClick(props.addMenuOptions[0].optionKey!);
    } else {
      setIsOpenAddMenu((prev) => !prev);
    }
  };

  const buttonTranslationKey: string =
    props.addMenuOptions.length === 1
      ? props.addMenuOptions[0].label
      : 'userManagement.add';

  return (
    <div className="relative inline-block">
      <AddButton
        className="px-12 py-2 rounded-full text-sm whitespace-nowrap"
        onClick={handleClickAddButton}
      >
        <Trans i18nKey={buttonTranslationKey} />
      </AddButton>

      {isOpenAddMenu && (
        <DropdownMenu
          className="left-0 w-44"
          options={props.addMenuOptions}
          onSelect={props.handleClick}
          onClose={() => setIsOpenAddMenu(false)}
        />
      )}
    </div>
  );
};

export const getUserTableHeader = (): TableHeader<GetUsersResponse>[] => {
  const validAuthToken: AuthTokenResponse | null = validateAndDecodeAuthToken();

  return [
    {
      generateCellContent: (user: GetUsersResponse) =>
        getFullName(user.firstName, user.lastName),
      header: UserManagementHeaderKey.NAME_PHOTO,
      sortable: true,
      key: UserKey.FIRST_NAME,
    },
    {
      generateCellContent: (user: GetUsersResponse) => (
        <>
          <span
            className={`w-2 h-2 mr-2 rounded-full inline-block ${getStatusDotColor(
              user.status,
            )}`}
          />
          {user.status.charAt(0).toUpperCase() +
            user.status.slice(1).toLowerCase()}
        </>
      ),
      header: UserManagementHeaderKey.STATUS,
      sortable: true,
      key: UserKey.STATUS,
    },
    {
      generateCellContent: (user: GetUsersResponse) => startCase(user.type),
      header: UserManagementHeaderKey.USER_TYPE,
      sortable: true,
      key: UserKey.TYPE,
    },

    ...(validAuthToken?.type === UserType.ORGANIZATION_ADMIN
      ? [
          {
            generateCellContent: (user: GetUsersResponse) =>
              user.subOrganizations?.length
                ? user.subOrganizations
                    .map((subOrg: OrganizationUnitNameAndId) => subOrg.name)
                    .join(', ')
                : '-',
            header: UserManagementHeaderKey.SUB_ORGANISATION,
          },
        ]
      : []),
    ...(validAuthToken?.type === UserType.ORGANIZATION_ADMIN ||
    validAuthToken?.type === UserType.SUB_ORGANIZATION_ADMIN
      ? [
          {
            generateCellContent: (user: GetUsersResponse) =>
              user?.venue?.name ?? '-',
            header: UserManagementHeaderKey.VENUE,
          },
        ]
      : []),
    {
      generateCellContent: (user: GetUsersResponse) =>
        user.venueBranchs?.length
          ? user.venueBranchs
              .map((branch: OrganizationUnitNameAndId) => branch.name)
              .join(', ')
          : '-',
      header: UserManagementHeaderKey.VENUE_BRANCH,
      sortable: false,
    },
    {
      generateCellContent: (user: GetUsersResponse) => user.email ?? '-',
      header: UserManagementHeaderKey.EMAIL,
      sortable: false,
    },
    {
      generateCellContent: (user: GetUsersResponse) => user.mobileNumber ?? '-',
      header: UserManagementHeaderKey.MOBILE,
      sortable: false,
    },
    ...(validAuthToken?.type !== UserType.ORGANIZATION_ADMIN &&
    validAuthToken?.type !== UserType.SUB_ORGANIZATION_ADMIN
      ? [
          {
            generateCellContent: (user: GetUsersResponse) =>
              user?.addedBy?.firstName +
              ' ' +
              user?.addedBy?.lastName +
              ', ' +
              moment(user.addedBy?.date).format('DD/MM/YYYY'),
            header: UserManagementHeaderKey.ADDED_BY,
            sortable: false,
          },
        ]
      : []),
  ];
};

/**
 * Sorts two string values alphabetically based on the specified order.
 *
 * @param a - The first string to compare.
 * @param b - The second string to compare.
 * @param order - The sorting order (`ASC` for ascending, `DESC` for descending).
 * @returns A number indicating sort order for use in Array.prototype.sort.
 */
export const sortByName = (a: string, b: string, order: SortKey) => {
  return order === SortKey.ASC ? a.localeCompare(b) : b.localeCompare(a);
};

/**
 * Sorts two user statuses based on their position in the `statusOrder` array.
 *
 * @param a - The first user status.
 * @param b - The second user status.
 * @param order - The sorting order (`ASC` or `DESC`).
 * @returns A number indicating sort order for use in Array.prototype.sort.
 */
export const sortByStatus = (a: UserStatus, b: UserStatus, order: SortKey) => {
  const aIndex = statusOrder.indexOf(a);
  const bIndex = statusOrder.indexOf(b);
  return order === SortKey.ASC ? aIndex - bIndex : bIndex - aIndex;
};
/**
 * Sorts two user types based on their position in the `userTypeOrder` array.
 *
 * @param a - The first user type.
 * @param b - The second user type.
 * @param order - The sorting order (`ASC` or `DESC`).
 * @returns A number indicating sort order for use in Array.prototype.sort.
 */
export const sortByUserType = (a: UserType, b: UserType, order: SortKey) => {
  const aIndex = userTypeOrder.indexOf(a);
  const bIndex = userTypeOrder.indexOf(b);
  return order === SortKey.ASC ? aIndex - bIndex : bIndex - aIndex;
};

/**
 * @description Concatenates the first name and last name with a space in between.
 * @param firstName - The first name of the individual.
 * @param lastName - The last name of the individual.
 * @returns A string containing the full name.
 **/
export const getFullName = (firstName: string, lastName: string): string => {
  return `${firstName} ${lastName}`;
};

/**
 * Generates a list of action options based on a user's type and status.
 *
 * This function is typically used to populate a contextual menu (e.g., a kebab menu)
 * with available actions that can be performed on a user, such as Edit, Delete, Activate, etc.
 *
 * @param user - The user object, expected to contain `type` and `status` properties.
 * @returns An array of `Option` objects, each containing a `label` and a camelCased `value`.
 *
 * Logic:
 * - If the user has status `INVITED`, only 'Delete' and 'Resend Invitation' options are returned.
 * - For other statuses:
 *   - `VENUE_STAFF`: Gets status-based option (Activate/Inactivate), Edit, Delete, Generate New Pin.
 *   - `VENUE_MANAGER`: Gets status-based option, Edit, Delete.
 *   - `VENUE_ADMIN`, `SUB_ORGANIZATION_ADMIN`, `ORGANIZATION_ADMIN`: Gets status-based option and Edit.
 * - The status-based option is determined by checking if the user's status is ACTIVE or INACTIVE.
 */
export const getUserKebabOptions = <T, Kebabaction extends string = string>(
  user: T,
  loadingMenu: { rowIndex: number; action: Kebabaction } | null,
  rowIndex: number,
): OptionWithLoading<KebabOption>[] => {
  const { type, status } = user as { type: string; status: string };
  const options: OptionWithLoading<KebabOption>[] = [];

  const addOption = (option: KebabOption) => {
    options.push({
      label: option,
      value: camelCase(option),
      loading: false,
    });
  };

  const addStatusBasedOption = () => {
    if (status === UserStatus.ACTIVE) {
      addOption(KebabOption.InActivate);
    } else if (status === UserStatus.INACTIVE) {
      addOption(KebabOption.Activate);
    }
  };

  if (status === UserStatus.INVITED) {
    addOption(KebabOption.Delete);
    addOption(KebabOption.ResendInvitation);
  } else if (type === UserType.VENUE_STAFF) {
    addStatusBasedOption();
    addOption(KebabOption.Edit);
    addOption(KebabOption.Delete);
    addOption(KebabOption.GenerateNewPin);
  } else if (type === UserType.VENUE_MANAGER) {
    addStatusBasedOption();
    addOption(KebabOption.Edit);
    addOption(KebabOption.Delete);
  } else if (
    type === UserType.VENUE_ADMIN ||
    type === UserType.SUB_ORGANIZATION_ADMIN ||
    type === UserType.ORGANIZATION_ADMIN
  ) {
    addStatusBasedOption();
    addOption(KebabOption.Edit);
  }

  return options.map((option: OptionWithLoading<KebabOption>) => {
    return {
      ...option,
      loading:
        loadingMenu?.rowIndex === rowIndex &&
        loadingMenu?.action === option.value,
    };
  });
};

/**
 * Returns the current loading action menu object based on the loading states and active row index.
 *
 * This function helps determine which action (Resend Invitation, Activate, or Inactivate)
 * is currently loading for a given table row, identified by its index.
 * It returns an object with the row index and the action string in camelCase format,
 * or null if no loading state is active or the active row index is null.
 *
 * @param activeRowIndex - The index of the currently active row, or null if none.
 * @param invitationEmailLoading - Boolean indicating if the invitation email is loading.
 * @param activateDeactivateLoading - Boolean indicating if the activate/deactivate action is loading.
 * @param currentActivateAction - The current activate/deactivate action (either InActivate or Activate), or null.
 * @returns An object with `rowIndex` and `action` representing the loading action menu, or null if none.
 */
export const getLoadingActionMenu = (
  activeRowIndex: number | null,
  activateDeactivateLoading?: boolean,
  deleteUserLoading?: boolean,
  currentActivateAction?: string | null,
  downloadSweepReportLoading?: boolean,
): { rowIndex: number; action: string } | null => {
  if (activeRowIndex === null) return null;

  if (deleteUserLoading) {
    return {
      rowIndex: activeRowIndex,
      action: camelCase(KebabOption.Delete),
    };
  }

  if (activateDeactivateLoading) {
    return {
      rowIndex: activeRowIndex,
      action: camelCase(
        currentActivateAction === KebabOption.InActivate
          ? KebabOption.InActivate
          : KebabOption.Activate,
      ),
    };
  }

  if (downloadSweepReportLoading) {
    return {
      rowIndex: activeRowIndex,
      action: camelCase(KebabOption.Download),
    };
  }

  return null;
};

/**
 * Returns the settings menu options based on the logged-in user's type.
 *
 * If the user is an Organization Admin or Sub Organization Admin,
 * the function returns only the "Download" option.
 * For all other user types, it returns the full set of setting menu options.
 *
 * @param userType - The type of the logged-in user (may be undefined).
 * @returns An array of menu option objects applicable to the user type.
 */
export const getSettingsMenuForUser = (userType: UserType | undefined) => {
  if (
    userType === UserType.ORGANIZATION_ADMIN ||
    userType === UserType.SUB_ORGANIZATION_ADMIN
  ) {
    return downloadOption;
  } else if (
    userType === UserType.VENUE_MANAGER ||
    userType === UserType.VENUE_ADMIN
  ) {
    return [...settingMenuOption, ...addVenueBranchOption];
  }

  return settingMenuOption;
};

export const groupedChildOrganizationUnits = (
  groupedOrganizationData: GroupedOrganizationUnit | undefined,
) => {
  const childVenueBranchesOptions = (
    venueBranches: any = [], //Todo Getting issue on this type I will Add in next PR
  ): OrganizationUnitChildItem[] =>
    venueBranches.map((branch: GroupedVenueType) => ({
      label: branch.name,
      value: branch._id,
    }));

  // Helper to map venues with nested venue Options
  const childVenueOption = (
    venues: GroupedVenueType[] = [],
  ): OrganizationUnitChildItem[] =>
    venues.map((venue: GroupedVenueType) => {
      const venueBranchOptions = childVenueBranchesOptions(venue.venueBranches);
      return {
        label: venue.name,
        value: venue._id,
        nestedChildItem:
          venueBranchOptions.length > 0 ? venueBranchOptions : undefined,
      };
    });
  //For organization Type
  if (groupedOrganizationData?.type === OrganizationUnitType.ORGANIZATION) {
    const allSubOrganizationsOption: Option = {
      label: 'All Sub-Organizations',
      value: groupedOrganizationData._id,
    };

    const subOrgOptions: OrganizationUnitChildItem[] = (
      groupedOrganizationData.suborganizations || []
    ).map((subOrganization: GroupedSubOrganizationType) => {
      const allVenuesOption: OrganizationUnitChildItem = {
        label: `All ${subOrganization.name} Venues`,
        value: `${subOrganization._id}`,
      };

      const venueOptions: OrganizationUnitChildItem[] = childVenueOption(
        subOrganization.venues,
      );

      if (venueOptions.length > 0) {
        allVenuesOption.nestedChildItem = venueOptions;
      }

      return allVenuesOption;
    });

    return [allSubOrganizationsOption, ...subOrgOptions];
  }

  // For Sub-Orgnization type
  if (groupedOrganizationData?.type === OrganizationUnitType.SUB_ORGANIZATION) {
    const allVenuesOption: Option = {
      label: `All ${groupedOrganizationData.name} venues`,
      value: `${groupedOrganizationData._id}`,
    };

    const venueOptions: OrganizationUnitChildItem[] = childVenueOption(
      groupedOrganizationData.venues,
    );

    return [allVenuesOption, ...venueOptions];
  }

  //For venue type
  if (groupedOrganizationData?.type === OrganizationUnitType.VENUE) {
    const allUsersOption: Option = {
      label: 'All Users',
      value: groupedOrganizationData._id,
    };

    const venueBranchOptions: OrganizationUnitChildItem[] =
      childVenueBranchesOptions(groupedOrganizationData.venueBranches);

    return [allUsersOption, ...venueBranchOptions];
  }

  return [];
};
/**
 * Counts the number of users associated with a specific organization unit.
 *
 * This function filters the provided list of users to count how many belong to
 * the specified organization unit, including sub-organizations and venue branches.
 *
 * @param users - An array of user objects to filter.
 * @param organizationUnitId - The ID of the organization unit to count users for.
 * @param status - Optional parameter to filter users by their status (e.g., ACTIVE, INACTIVE) as well.
 * @returns The count of users associated with the specified organization unit.
 */
export const getUsersByOrganizationUnit = (
  users: GetUsersResponse[],
  organizationUnitId: string,
  status?: UserStatus,
): GetUsersResponse[] => {
  return users.filter((user) => {
    const userBelongsToOrganizationUnit: boolean =
      user.organization.id === organizationUnitId ||
      user.subOrganizations?.some(
        (subOrg) => subOrg.id === organizationUnitId,
      ) ||
      user.venueBranchs?.some((branch) => branch.id === organizationUnitId) ||
      user.venue?.id === organizationUnitId;
    if (userBelongsToOrganizationUnit && status) {
      return user.status === status;
    } else return userBelongsToOrganizationUnit;
  });
};

export function addUserCountToNestedItems(
  OrganizationUnitChildItems: OrganizationUnitChildItem[],
  users: GetUsersResponse[],
): OrganizationUnitChildItem[] {
  return OrganizationUnitChildItems.map(
    (OrganizationUnitChildItem: OrganizationUnitChildItem) => {
      const count = getUsersByOrganizationUnit(
        users,
        OrganizationUnitChildItem.value,
      ).length;

      return {
        ...OrganizationUnitChildItem,
        userCount: count,
        nestedChildItem: OrganizationUnitChildItem.nestedChildItem
          ? addUserCountToNestedItems(
              OrganizationUnitChildItem.nestedChildItem,
              users,
            )
          : [],
      };
    },
  );
}
